export enum LegListSortingOrderEnum {
  Descending = 1,
  Ascending = 2,
}
